import React from 'react';
import { Card } from 'react-bootstrap';
import { Outlet } from 'react-router-dom'
import '../mysass.scss';
import Cities from './Cities';
import Airport from './Airport';
import About from './About';
import ContactForm from './ContactForm';
import Nature from './Nature';
import Culture from './Culture';
import Lifestyle from './Lifestyle';





  const Home = () => {


  return (
    <>

    
  

<Card id='home' className="anchorshome bg-dark text-white" >
      <Card.Img className='homeimage' src="merge6.png" alt="Card image" style={{objectFit:'cover',opacity:'0.6'}} />
      <Card.ImgOverlay>
        <Card.Text className='card1' style={{fontFamily:'Black Ops One, cursive'}}>
           EXPLORE KOSOVO <br></br>WITH A TRIP
        </Card.Text>
      </Card.ImgOverlay>
    </Card>

        <About/>
        
        <Airport/> 


<br></br>

    <Cities/>   
<br></br>
    <Nature/>
<br></br>
    <Culture/>
<br></br> 
    <Lifestyle/>      


    <ContactForm/>

    <Outlet />


    </>
  )
}

export default Home